import { render } from "./ComponentNotFound.vue?vue&type=template&id=73e20478&scoped=true"
const script = {}

import "./ComponentNotFound.vue?vue&type=style&index=0&id=73e20478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e20478"]])

export default __exports__